// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/opportunity_watch.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.RecordOpportunitySourceRequest
 */ export class RecordOpportunitySourceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordOpportunitySourceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOpportunitySourceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOpportunitySourceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOpportunitySourceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string root_notice_id = 3;
   */ _define_property(this, "rootNoticeId", ""), /**
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * Canonical JSON of meaningful persisted source fields, excluding refresh times.
   *
   * @generated from field: string material_json = 5;
   */ _define_property(this, "materialJson", ""), /**
   * @generated from field: google.protobuf.Timestamp published_at = 6;
   */ _define_property(this, "publishedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 7;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: bool award_signal = 8;
   */ _define_property(this, "awardSignal", false), /**
   * Actual source modification time, when supplied; independent of publication.
   *
   * @generated from field: google.protobuf.Timestamp source_revision_at = 9;
   */ _define_property(this, "sourceRevisionAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOpportunitySourceRequest, "runtime", proto3);
_define_property(RecordOpportunitySourceRequest, "typeName", "mono.datagateway.v1.RecordOpportunitySourceRequest");
_define_property(RecordOpportunitySourceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "root_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "material_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "published_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "award_signal",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "source_revision_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordOpportunitySourceResponse
 */ export class RecordOpportunitySourceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordOpportunitySourceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOpportunitySourceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOpportunitySourceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOpportunitySourceResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOpportunitySourceResponse, "runtime", proto3);
_define_property(RecordOpportunitySourceResponse, "typeName", "mono.datagateway.v1.RecordOpportunitySourceResponse");
_define_property(RecordOpportunitySourceResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.OpportunityWatch
 */ export class OpportunityWatch extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityWatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityWatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityWatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityWatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: bool watching = 3;
   */ _define_property(this, "watching", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp stopped_at = 5;
   */ _define_property(this, "stoppedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityWatch, "runtime", proto3);
_define_property(OpportunityWatch, "typeName", "mono.datagateway.v1.OpportunityWatch");
_define_property(OpportunityWatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "watching",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "stopped_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityWatchRequest
 */ export class GetOpportunityWatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityWatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityWatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityWatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityWatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityWatchRequest, "runtime", proto3);
_define_property(GetOpportunityWatchRequest, "typeName", "mono.datagateway.v1.GetOpportunityWatchRequest");
_define_property(GetOpportunityWatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetOpportunityWatchRequest
 */ export class SetOpportunityWatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityWatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityWatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityWatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityWatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: bool watching = 4;
   */ _define_property(this, "watching", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityWatchRequest, "runtime", proto3);
_define_property(SetOpportunityWatchRequest, "typeName", "mono.datagateway.v1.SetOpportunityWatchRequest");
_define_property(SetOpportunityWatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "watching",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityWatchResponse
 */ export class GetOpportunityWatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityWatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityWatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityWatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityWatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Absent when this user has never watched this Opportunity.
   *
   * @generated from field: mono.datagateway.v1.OpportunityWatch watch = 1;
   */ _define_property(this, "watch", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityWatchResponse, "runtime", proto3);
_define_property(GetOpportunityWatchResponse, "typeName", "mono.datagateway.v1.GetOpportunityWatchResponse");
_define_property(GetOpportunityWatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "watch",
            kind: "message",
            T: OpportunityWatch
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetOpportunityWatchResponse
 */ export class SetOpportunityWatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityWatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityWatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityWatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityWatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityWatch watch = 1;
   */ _define_property(this, "watch", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityWatchResponse, "runtime", proto3);
_define_property(SetOpportunityWatchResponse, "typeName", "mono.datagateway.v1.SetOpportunityWatchResponse");
_define_property(SetOpportunityWatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "watch",
            kind: "message",
            T: OpportunityWatch
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OpportunityActivity
 */ export class OpportunityActivity extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityActivity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityActivity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityActivity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityActivity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * publication_change, confirmed_evidence, relationship_correction.
   * Proposed associations never appear as confirmed evidence.
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string notice_id = 4;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string publication_id = 5;
   */ _define_property(this, "publicationId", ""), /**
   * @generated from field: string summary = 6;
   */ _define_property(this, "summary", ""), /**
   * Unknown source times remain absent; retrieval is never publication time.
   *
   * @generated from field: google.protobuf.Timestamp published_at = 7;
   */ _define_property(this, "publishedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 8;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp associated_at = 9;
   */ _define_property(this, "associatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp recorded_at = 10;
   */ _define_property(this, "recordedAt", void 0), /**
   * Immutable source content for this exact event; never a live Notice lookup.
   *
   * @generated from field: string source_version = 11;
   */ _define_property(this, "sourceVersion", ""), /**
   * @generated from field: string source_material_json = 12;
   */ _define_property(this, "sourceMaterialJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityActivity, "runtime", proto3);
_define_property(OpportunityActivity, "typeName", "mono.datagateway.v1.OpportunityActivity");
_define_property(OpportunityActivity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "publication_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "published_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "associated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "recorded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "source_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_material_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOpportunityActivityRequest
 */ export class ListOpportunityActivityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityActivityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityActivityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityActivityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityActivityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityActivityRequest, "runtime", proto3);
_define_property(ListOpportunityActivityRequest, "typeName", "mono.datagateway.v1.ListOpportunityActivityRequest");
_define_property(ListOpportunityActivityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOpportunityActivityResponse
 */ export class ListOpportunityActivityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityActivityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityActivityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityActivityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityActivityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OpportunityActivity activities = 1;
   */ _define_property(this, "activities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityActivityResponse, "runtime", proto3);
_define_property(ListOpportunityActivityResponse, "typeName", "mono.datagateway.v1.ListOpportunityActivityResponse");
_define_property(ListOpportunityActivityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "activities",
            kind: "message",
            T: OpportunityActivity,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityActivityRequest
 */ export class GetOpportunityActivityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityActivityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityActivityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityActivityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityActivityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityActivityRequest, "runtime", proto3);
_define_property(GetOpportunityActivityRequest, "typeName", "mono.datagateway.v1.GetOpportunityActivityRequest");
_define_property(GetOpportunityActivityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityActivityResponse
 */ export class GetOpportunityActivityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityActivityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityActivityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityActivityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityActivityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityActivity activity = 1;
   */ _define_property(this, "activity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityActivityResponse, "runtime", proto3);
_define_property(GetOpportunityActivityResponse, "typeName", "mono.datagateway.v1.GetOpportunityActivityResponse");
_define_property(GetOpportunityActivityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "activity",
            kind: "message",
            T: OpportunityActivity
        }
    ]));
/**
 * Landscapes share the canonical Opportunity tenant-root authority. An owner
 * restricts personal context; an empty owner selects all permitted Team context.
 *
 * @generated from message mono.datagateway.v1.ListGrowthHomeContextsRequest
 */ export class ListGrowthHomeContextsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthHomeContextsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthHomeContextsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthHomeContextsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthHomeContextsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated string pursuit_ids = 2;
   */ _define_property(this, "pursuitIds", []), /**
   * @generated from field: repeated string proposal_ids = 3;
   */ _define_property(this, "proposalIds", []), /**
   * @generated from field: repeated string rfi_ids = 4;
   */ _define_property(this, "rfiIds", []), /**
   * @generated from field: string landscape_owner = 5;
   */ _define_property(this, "landscapeOwner", ""), /**
   * Trusted caller derives this from its principal, in both My and Team lenses.
   * Watches are personal intent, never an authorization grant to linked work.
   *
   * @generated from field: string watch_user_id = 6;
   */ _define_property(this, "watchUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthHomeContextsRequest, "runtime", proto3);
_define_property(ListGrowthHomeContextsRequest, "typeName", "mono.datagateway.v1.ListGrowthHomeContextsRequest");
_define_property(ListGrowthHomeContextsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pursuit_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "proposal_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "rfi_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "landscape_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "watch_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GrowthHomeSourceContext
 */ export class GrowthHomeSourceContext extends Message {
    static fromBinary(bytes, options) {
        return new GrowthHomeSourceContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthHomeSourceContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthHomeSourceContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthHomeSourceContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * Landscapes and watched Opportunities supply titles under tenant-root authority;
   * workspace titles come from authorized lists.
   *
   * @generated from field: string title = 4;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthHomeSourceContext, "runtime", proto3);
_define_property(GrowthHomeSourceContext, "typeName", "mono.datagateway.v1.GrowthHomeSourceContext");
_define_property(GrowthHomeSourceContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGrowthHomeContextsResponse
 */ export class ListGrowthHomeContextsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthHomeContextsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthHomeContextsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthHomeContextsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthHomeContextsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GrowthHomeSourceContext contexts = 1;
   */ _define_property(this, "contexts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthHomeContextsResponse, "runtime", proto3);
_define_property(ListGrowthHomeContextsResponse, "typeName", "mono.datagateway.v1.ListGrowthHomeContextsResponse");
_define_property(ListGrowthHomeContextsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contexts",
            kind: "message",
            T: GrowthHomeSourceContext,
            repeated: true
        }
    ]));
